import PolicyPage, { Section } from './PolicyPage'
import SourceLinks from '../components/docs/SourceLinks'
export default function AccessibilityPage() {
  return (
    <PolicyPage
      title="Accessibility"
      intro="Accessibility is designed into every token, theme and component, and verified on every route."
    >
      <Section id="target" heading="Implementation target">
        <p>
          MDS uses WCAG 2.1 Level AA as its engineering target. The Revised
          Section 508 standards incorporate WCAG 2.0 Level A and AA for covered
          web content. Teams should confirm the requirements applicable to their
          own system.
        </p>
        <p>
          The tokens, guidance and examples support implementation. Conformance
          and authorization are evaluated for each application in its operating
          context.
        </p>
      </Section>
      <Section id="testing" heading="How the experience is checked">
        <p>
          The test suite includes component-level axe checks on every route,
          rendered-page accessibility scans, keyboard interactions and 320 CSS
          pixel reflow checks.
        </p>
        <p>
          Automated checks cover part of accessibility. Manual keyboard, zoom,
          assistive-technology and usability review remain part of release
          verification.
        </p>
      </Section>
      <Section id="features" heading="Using the documentation">
        <p>
          A skip link takes keyboard users to the main content. Navigation and
          examples use labeled controls, visible focus and text-based status
          messages. Light and dark themes, and every mission theme, meet WCAG
          AA contrast for each role pairing. Motion, including the home page
          photographs and side-scrolling tour, respects the reduced-motion
          preference.
        </p>
        <p>
          The pattern examples use illustrative data and keep interaction state
          in the current page.
        </p>
      </Section>
      <SourceLinks ids={['accessibility', 'section508']} />
    </PolicyPage>
  )
}
